/**
 * Catálogo único de eventos PostHog del front.
 *
 * Toda llamada a `PosthogService.capture(...)` debe usar una constante de
 * este fichero. Sirve para:
 *  - Ver de un vistazo todos los eventos que emite la aplicación.
 *  - Renombrar un evento en un único sitio sin tocar 30 llamadas.
 *  - Tipar el primer argumento de `capture()` para detectar typos en build.
 *
 * Convención: el valor (string) es el que llega a PostHog; mantenerlo en
 * snake_case y alineado con el backend (`PosthogService.capture` en api-v2).
 */
export const POSTHOG_EVENTS = {
  // Auth & login
  loginSuccess: 'login_success',
  loginFailed: 'login_failed',

  // Consent banner
  analyticsConsentUpdated: 'analytics_consent_updated',

  // Invitation funnel (gestoría → autónomo)
  invitationPageViewed: 'invitation_page_viewed',
  invitationEmailLinkViewed: 'invitation_email_link_viewed',
  invitationLinkInvalid: 'invitation_link_invalid',
  invitationCompanyLoaded: 'invitation_company_loaded',
  invitationCompanyLoadFailed: 'invitation_company_load_failed',
  invitationAcceptFailed: 'invitation_accept_failed',

  // Invite client (gestoría)
  inviteClientModalOpened: 'invite_client_modal_opened',
  inviteClientFormAbandoned: 'invite_client_form_abandoned',
  inviteClientFailed: 'invite_client_failed',
  bulkInviteModalOpened: 'bulk_invite_modal_opened',
  bulkInviteLaunched: 'bulk_invite_launched',
  bulkInviteCompleted: 'bulk_invite_completed',
  generateInviteLinkClicked: 'generate_invite_link_clicked',
  gestoriaInviteLinkGenerated: 'gestoria_invite_link_generated',

  // Email integration
  emailConnectModalOpened: 'email_connect_modal_opened',
  emailProviderClicked: 'email_provider_clicked',
  emailConnectionSucceeded: 'email_connection_succeeded',
  emailConnectionFailed: 'email_connection_failed',

  // New communication (consulta, trámite, campaña)
  communicationTypePickerOpened: 'communication_type_picker_opened',
  communicationTypeSelected: 'communication_type_selected',

  // Campaigns
  campaignCreateStarted: 'campaign_create_started',
  campaignLaunched: 'campaign_launched',

  // Clients list
  clientsListViewed: 'clients_list_viewed',
  clientCardClicked: 'client_card_clicked',

  // Configuration
  companySettingsSaved: 'company_settings_saved',
  companySettingsSaveFailed: 'company_settings_save_failed',
  onboardingConfigUpdated: 'onboarding_config_updated',
  onboardingConfigUpdateFailed: 'onboarding_config_update_failed'
} as const;

export type PosthogEvent = (typeof POSTHOG_EVENTS)[keyof typeof POSTHOG_EVENTS];
